import { PageDefinition } from '@fullstory/proto/fs/api/pages';
import {
  ComputePageFlowRequest,
  QueryCacheOptions,
  SampleOptions,
} from '@fullstory/proto/fs/services/alexa';
import { MLState } from '@fullstory/proto/fs/services/paige';

export enum PageRequestTypes {
  GetAllPagesRequest = 'Pages.GetAll.Request',
  GetAllPagesSuccess = 'Pages.GetAll.Success',
  GetAllPagesFailure = 'Pages.GetAll.Failure',
  MatchPageRequest = 'Pages.Match.Request',
  MatchPageSuccess = 'Pages.Match.Success',
  MatchPageFailure = 'Pages.Match.Failure',
  SetMLStateRequest = 'Pages.SetMLState.Request',
  SetMLStateSuccess = 'Pages.SetMLState.Success',
  SetMLStateFailure = 'Pages.SetMLState.Failure',
  SetPageRequest = 'Pages.Set.Request',
  SetPageSuccess = 'Pages.Set.Success',
  SetPageFailure = 'Pages.Set.Failure',
  ArchivePageRequest = 'Pages.Archive.Request',
  ArchivePageSuccess = 'Pages.Archive.Success',
  ArchivePageFailure = 'Pages.Archive.Failure',
  ArchivePagesRequest = 'Pages.ArchiveMulti.Request',
  ArchivePagesSuccess = 'Pages.ArchiveMulti.Success',
  ArchivePagesFailure = 'Pages.ArchiveMulti.Failure',
  UnarchivePageRequest = 'Pages.Unarchive.Request',
  UnarchivePageSuccess = 'Pages.Unarchive.Success',
  UnarchivePageFailure = 'Pages.Unarchive.Failure',
  ComputePageFlowRequest = 'Pages.ComputePageFlow.Request',
  ComputePageFlowSuccess = 'Pages.ComputePageFlow.Success',
  ComputePageFlowFailure = 'Pages.ComputePageFlow.Failure',
  AutocompleteRequest = 'Pages.Autocomplete.Request',
  AutocompleteSuccess = 'Pages.Autocomplete.Success',
  AutocompleteFailure = 'Pages.Autocomplete.Failure',
  SearchRequest = 'Pages.Search.Request',
  SearchSuccess = 'Pages.Search.Success',
  SearchFailure = 'Pages.Search.Failure',
  PageAppCacheIsLoading = 'Pages.APP_CACHE_IS_LOADING',
  PageAppCacheLoadFailed = 'Pages.APP_CACHE_LOAD_FAILED',
  PageAppCacheRefetching = 'Pages.APP_CACHE_IS_REFETCHING',
  PageAppCacheHasData = 'Pages.APP_CACHE_HAS_DATA',
  PageAppCacheFresh = 'Pages.APP_CACHE_FRESH',
  PageAppCacheSwap = 'Pages.APP_CACHE_SWAP',
  PageAppCacheClear = 'Pages.APP_CACHE_CLEAR',
  SilenceIssueRequest = 'Pages.SilenceIssue.Request',
  SilenceIssueSuccess = 'Pages.SilenceIssue.Success',
  SilenceIssueFailure = 'Pages.SilenceIssue.Failure',
  UnsilenceIssueRequest = 'Pages.UnsilenceIssue.Request',
  UnsilenceIssueSuccess = 'Pages.UnsilenceIssue.Success',
  UnsilenceIssueFailure = 'Pages.UnsilenceIssue.Failure',
  GetSuggestedPageRequest = 'Pages.GetSuggestedPage.Request',
  GetSuggestedPageSuccess = 'Pages.GetSuggestedPage.Success',
  GetSuggestedPageFailure = 'Pages.GetSuggestedPage.Failure',
  MatchUrlsRequest = 'Pages.MatchUrls.Request',
  MatchUrlsSuccess = 'Pages.MatchUrls.Success',
  MatchUrlsFailure = 'Pages.MatchUrls.Failure',
}

export type PagesState = {
  pages: Map<number, PageDefinition>;
  learnedLimit?: number;
  maxPages?: number;
  mlState?: MLState;
  urlMatches: {
    urls: string[];
    matches: Map<string, PageDefinition>;
  };
};

export interface PageFlowRequestBody
  extends Omit<ComputePageFlowRequest, 'now' | 'timezone' | 'cacheOptions' | 'sampleOptions'> {
  cacheOptions?: QueryCacheOptions;
  sampleOptions?: SampleOptions;
}
